import React, { FC } from 'react';
import ImageHandlingPopup from '@v2/components/imageHandling/components/Header/components/ImageHandlingPopup';
import { useManageRotateModal } from './hooks/useManageRotateModal';
import { ImageHandlingHeaderProps } from '@v2/components/imageHandling/components/Header/Header';

export interface RotateModalProps extends Pick<ImageHandlingHeaderProps, 'images' | 'selectedIndex' | 'C' | 'rotateImage'> {
  showRotatePopUp: boolean;
  triggerRotatePopUp: () => void;
  iconPosition?: { x: number; y: number };
}

const RotateModal: FC<RotateModalProps> = ({ C, showRotatePopUp, triggerRotatePopUp, rotateImage, images, selectedIndex, iconPosition }) => {
  const { list } = useManageRotateModal({ rotateImage, images, selectedIndex });

  if (!showRotatePopUp) return null;

  return <ImageHandlingPopup {...{ C, list, loading: false, onClose: triggerRotatePopUp, iconPosition }} />;
};

export default RotateModal;
